import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as EditInterviewIconSvg } from '../../../assets/icons/edit-interview.svg';

export default function EditInterviewIcon() {
  return <SvgIcon component={EditInterviewIconSvg} sx={{ '& path': { fill: 'white' } }} />;
}
